import { twc } from "react-twc"

export const H1 = twc.h1`font-medium text-2xl`
export const Ul = twc.ul``
export const Li = twc.li`relative mb-2 last:mb-0 pl-4 before:absolute before:content-[""] before:top-1.5 before:left-0 before:w-2 before:h-2 before:rounded-full before:bg-primary`
